/*
 * VTee モーダル制御
 * ─ data-vtee-modal-trigger="<id>" 要素クリックで対応する <dialog data-vtee-modal="<id>"> を開く
 * ─ data-vtee-modal-close 要素クリックで親モーダルを閉じる
 * ─ 背景クリック (dialog 要素自体のクリック) で閉じる
 * ─ ESC は <dialog> 標準で自動対応
 */
(function () {
  'use strict';

  function findModal(id) {
    return document.querySelector('[data-vtee-modal="' + (id || '').replace(/"/g, '\\"') + '"]');
  }

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  // PC は右(X)、モバイルは下(Y)から。表示中=0、退避=100%。
  function slideKeyframes(reverse) {
    var off = isMobile() ? 'translateY(100%)' : 'translateX(100%)';
    var on = isMobile() ? 'translateY(0)' : 'translateX(0)';
    return reverse
      ? [{ transform: on }, { transform: off }]
      : [{ transform: off }, { transform: on }];
  }
  // inner 上の全アニメをキャンセルし、残留インラインも消す。
  // ※ 閉アニメ(fill:forwards)が残ると次オープンで入場後に画面外へ戻され「表示されない」。
  function resetInnerAnims(inner) {
    if (!inner) return;
    try {
      inner.getAnimations().forEach(function (a) {
        a.cancel();
      });
    } catch (e) {}
    inner.style.transform = '';
  }

  function openModal(id) {
    var modal = findModal(id);
    if (!modal) return;
    modal.classList.remove('vtee-modal--closing');

    var inner = modal.querySelector('.vtee-modal__inner');
    resetInnerAnims(inner);

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      // <dialog> 未対応ブラウザのフォールバック
      modal.setAttribute('open', '');
      modal.classList.add('is-open');
    }
    document.body.classList.add('vtee-modal-open');

    // 入場アニメは Web Animations API で実行する。
    // ※ <dialog> のトップレイヤーでは CSS transition の transform が「計算値は動くが
    //   実描画は動かない」既知の挙動があり一瞬で表示されてしまう。element.animate() は
    //   確実に描画されるため WAAPI を採用。
    // fill:'both' で終了後も定位置(0)を保持し、画面外へ戻らないようにする。
    if (inner && inner.animate && !reduceMotion()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var anim = inner.animate(slideKeyframes(false), {
            duration: 400,
            easing: 'cubic-bezier(0, 0, 0.2, 1)',
            fill: 'none',
          });

          anim.onfinish = function () {
            anim.cancel();
            inner.style.transform = '';
          };
        });
      });
    }
  }

  function finalizeClose(modal) {
    modal.classList.remove('vtee-modal--closing');
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
      modal.classList.remove('is-open');
    }
    if (!document.querySelector('[data-vtee-modal][open]')) {
      document.body.classList.remove('vtee-modal-open');
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    // 二重クローズ防止 (アニメ中の再クリック等)
    if (modal.classList.contains('vtee-modal--closing')) return;
    modal.classList.add('vtee-modal--closing');

    var inner = modal.querySelector('.vtee-modal__inner');
    // 入場アニメ(fill:both)が残っているので一旦全キャンセル → 定位置(0)から退場を始める
    resetInnerAnims(inner);

    if (!inner || !inner.animate || reduceMotion()) {
      finalizeClose(modal);
      return;
    }
    // 退場アニメ (WAAPI): 定位置(0)→画面外へスライド → 完了で実クローズ
    var anim = inner.animate(slideKeyframes(true), {
      duration: 300,
      easing: 'cubic-bezier(0.4, 0, 1, 1)',
      fill: 'forwards',
    });
    var done = false;
    var end = function () {
      if (done) return;
      done = true;
      finalizeClose(modal);
    };
    anim.onfinish = end;
    window.setTimeout(end, 450); // onfinish が来ない場合の保険
  }

  document.addEventListener('click', function (e) {
    // open
    var opener = e.target.closest('[data-vtee-modal-trigger]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-vtee-modal-trigger'));
      return;
    }
    // close button
    var closer = e.target.closest('[data-vtee-modal-close]');
    if (closer) {
      e.preventDefault();
      closeModal(closer.closest('[data-vtee-modal]'));
      return;
    }
    // backdrop click — クリックターゲットが dialog 自体なら閉じる
    if (e.target.matches('[data-vtee-modal]')) {
      var rect = e.target.getBoundingClientRect();
      // <dialog> の中身は .vtee-modal__inner なので、dialog 直下クリック = 背景
      var clickedInBackdrop =
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom ||
        !e.target.querySelector('.vtee-modal__inner').contains(e.target);
      // 単純に target が dialog 自体ならクローズ
      closeModal(e.target);
    }
  });

  // ESC キー: <dialog> ネイティブの即時クローズを止めて、アニメ付きクローズにする
  document.addEventListener(
    'cancel',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-vtee-modal]')) {
        e.preventDefault();
        closeModal(e.target);
      }
    },
    true
  );

  // <dialog> の close イベントで body class を解除
  document.addEventListener(
    'close',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-vtee-modal]')) {
        if (!document.querySelector('[data-vtee-modal][open]')) {
          document.body.classList.remove('vtee-modal-open');
        }
      }
    },
    true
  );

  // data-vtee-modal-autoopen が付いたモーダルはページ読み込み時に自動でオープン
  // ─ 商品説明を読ませたい PDP のアイテム詳細モーダル等で使用
  function autoOpenModals() {
    var modals = document.querySelectorAll('[data-vtee-modal-autoopen]');
    modals.forEach(function (modal) {
      var id = modal.getAttribute('data-vtee-modal');
      if (id) openModal(id);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenModals);
  } else {
    autoOpenModals();
  }
})();
